export enum FeaturedImageObjectFit {
    COVER = 'cover',
    CONTAIN = 'contain',
}
